import { calculatePitchesForPitchChange } from "@/components/pitchCorrection/pitchKnob/calculatePitchesForPitchChange";
import { Marker } from "@/types/defs/pitchCorrection/marker";

export const pitchDiffsFromSemitoneData = (
  pitches: number[],
  keyz: number[],
  circles: Marker[]
) => {
  const vci = calculatePitchesForPitchChange(100, keyz, circles, 0, pitches);
  return pitches.map((p, ix) => (p === 0 ? 0 : p - vci[ix]));
};
